export default __webpack_public_path__ + "static/media/card3_right.4ac3526b.png";